module.exports = __webpack_public_path__ + "img/suc_loading.c86e0aec.gif";